import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ParallaxStandaloneDirective } from '@yoozly/ngx-parallax';
import { Home, Media } from '../../types/payload-types';
import { PayloadService } from '../../services/payload.service';
import { YoutubeComponent } from '../../components/youtube/youtube.component';
import { MediaCardComponent } from '../../components/media-card/media-card.component';
import { CtaComponent } from '../../components/cta/cta.component';
import { SafeUrlPipe } from '../../pipes/safe-url-pipe';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [YoutubeComponent, MediaCardComponent, CtaComponent, RouterLink],
})
export class HomeComponent {
  title = 'cometralci';

  data: Home | undefined;

  constructor(
    private payloadService: PayloadService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    console.log('get home page');
    this.payloadService.getHomePage().subscribe((res: Home) => {
      console.log(res);
      this.data = res;
    });
  }
  sanitize(url: string | Media) {
    const urlString = typeof url === 'string' ? url : url?.url ?? '';
    return this.sanitizer.bypassSecurityTrustUrl(urlString);
  }
}
